import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Membership } from '@spike/membership-model';
import Pet from '@spike/pet-model';
import PetInfo from 'components/OrderDetail/PetDetail/PetInfo';
import { Button } from 'components/UI';
import { FunctionComponent } from 'react';
import MembershipInfo from './MembershipInfo';

export interface PetsMembershipProps {
    pets: Array<Pet>;
    membership?: Membership;
    loading?: boolean;
    className?: string;
    onEdit: () => void;
    onDeletePet: (petId: number) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            height: '100%',
            width: '100%'
        },
        title: {
            fontWeight: 600,
            paddingBottom: 24,
            fontSize: 16,
            lineHeight: '16px'
        },
        addPetButton: {
            'height': 43,
            'width': 'fit-content',
            'padding': '8px 16px !important',
            '& .MuiButton-label': {
                fontSize: 14,
                lineHeight: '27px'
            }
        },
        petsContainer: {
            paddingLeft: 16,
            paddingRight: 16,
            paddingBottom: 20,
            border: '1px solid #D4D4D4',
            borderRadius: 8
        },
        pet: {
            marginTop: 20,
            paddingBottom: 20,
            borderBottom: '1px solid #D4D4D4'
        },
        membershipInfo: {
            marginTop: 20
        }
    })
);

export const PetsMembership: FunctionComponent<PetsMembershipProps> = props => {
    const classes = useStyles(props);

    return (
        <Box className={classes.container}>
            <Typography className={classes.title}>Pets</Typography>
            {props.pets.length === 0 ? (
                <Button
                    color="green"
                    label="+ Add Pets"
                    size="small"
                    className={classes.addPetButton}
                    onClick={props.onEdit}
                />
            ) : (
                <Box className={classes.petsContainer}>
                    {props.pets.map(pet => (
                        <PetInfo
                            key={pet.id}
                            pet={pet}
                            className={classes.pet}
                            onDelete={() => props.onDeletePet && props.onDeletePet(pet.id ?? 0)}
                        />
                    ))}
                    {props.membership && (
                        <MembershipInfo
                            membership={props.membership}
                            onEdit={props.onEdit}
                            disabled={props.loading}
                            className={classes.membershipInfo}
                        />
                    )}
                </Box>
            )}
        </Box>
    );
};

export default PetsMembership;
